import Model from './Model'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
dayjs.extend(utc)

export default class Request extends Model {
  resource() {
    return 'admin/files'
  }

  get addedDate() {
    return dayjs
      .utc(this.created_at)
      .local()
      .format('MMM DD, YYYY hh:mm A')
  }

  get updatedDate() {
    return dayjs
      .utc(this.updated_at)
      .local()
      .format('MMM DD, YYYY hh:mm A')
  }
}
